/** Validation for landing promo image uploads (server removes background). */

const MAX_FILE_BYTES = 12 * 1024 * 1024;

export type BgRemovalProgress = {
  percent: number;
  stageKey: string;
};

export function validatePromotionImageFile(file: File): 'not_image' | 'too_large' | null {
  if (!file.type.startsWith('image/')) return 'not_image';
  if (file.size > MAX_FILE_BYTES) return 'too_large';
  return null;
}
